import projectListEmptyStateIllustration from "../../assets/images/projectListEmptyStateIllustration.webp";

import style from "./ProjectPromo.module.css";

export const ProjectPromo = () => {
  return (
    <div className={style.pageContainer}>
      <div className={style.promoContainer}>
        <img
          src={projectListEmptyStateIllustration}
          alt="No shared projects illustration"
          className={style.illustration}
        />
        <div className={style.title}>No shared projects yet</div>
        <div className={style.subtitle}>
          Projects shared with you in this team will appear here.
        </div>
      </div>
    </div>
  );
};
